import { debounce } from "@mongez/reinforcements";
import { useCallback, useMemo, useState } from "react";

export type UseSearchProps = {
  onSearch: (value: string) => void;
};

export function useSearch({ onSearch }: UseSearchProps) {
  const [search, setSearch] = useState("");

  const searchDebounce = useMemo(() => debounce(onSearch, 500), [onSearch]);

  const handleSearch = useCallback(
    (value: string) => {
      setSearch(value);
      searchDebounce(value);
    },
    [searchDebounce],
  );

  return { search, handleSearch };
}
